import {memo, useEffect} from 'react';

import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import FuseSvgIcon from '@/@fuse/core/FuseSvgIcon';
import {PaymentLinkLogo} from '@/app/main/paymentLink/components/PaymentLinkLogo/PaymentLinkLogo';
import {
  CPaymentLinkStatuses,
  PaymentLinkUtm,
} from '@/app/main/paymentLink/models/constants/paymentLink.constants';
import PaymentLinkV2Promo from '@/app/main/paymentLink/v2/pages/paymentLinkV2/components/PaymentLinkV2Promo/PaymentLinkV2Promo';
import {IPaymentLinkV2ValidProps} from '@/app/main/paymentLink/v2/pages/paymentLinkV2/models/interfaces/paymentLinkV2.interfaces';
import {usePaymentLinkTrackers} from '@/dataSource/src/api/payment-link/trackers';

import './styles';

interface PaymentLinkV2ExpiredProps {
  props: IPaymentLinkV2ValidProps;
}

export const PaymentLinkV2Expired = memo(
  ({props}: PaymentLinkV2ExpiredProps) => {
    const {t} = useTranslation();
    const {trackViewRequestMoneyLinkExpired} = usePaymentLinkTrackers();

    useEffect(() => {
      trackViewRequestMoneyLinkExpired({
        id: props.paymentLinkId,
        link_consumed: props.link_consumed,
        receiver_user: {
          id: props.receiverUserId,
          name: props.name,
        },
        single_payment: props.single_payment,
        status: CPaymentLinkStatuses.USED,
        amount: props.amount,
        gif: props.gif,
        information: {
          gif: props.gif,
          note: props.note,
        },
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <section className="payment-link-v2-expired-background">
        <Box className="payment-link-v2-expired-container">
          <PaymentLinkLogo />

          <Box className="payment-link-v2-expired-hero">
            <Box className="payment-link-v2-expired-badge">
              <FuseSvgIcon
                size={24}
                className="payment-link-v2-expired-badge-icon">
                heroicons-outline:x-circle
              </FuseSvgIcon>
            </Box>

            <Box className="payment-link-v2-expired-text">
              <Typography
                component="h1"
                className="payment-link-v2-expired-title">
                {t('payment_link.link_already_used')}
              </Typography>
              <Typography className="payment-link-v2-expired-subtitle">
                {t('payment_link.payment_already_completed')}
              </Typography>
            </Box>
          </Box>

          <PaymentLinkV2Promo
            utmCampaign={PaymentLinkUtm.Campaign.LINK}
            utmMedium={PaymentLinkUtm.Medium.Completed}
          />
        </Box>
      </section>
    );
  },
);

PaymentLinkV2Expired.displayName = 'PaymentLinkV2Expired';
